export default function Banner({ img, alt, addStyle, text }) {
    return (
        <div className="w-100 h-100 banner-container" style={{ ...addStyle }} data-text={text}>
            <img src={img} alt={alt} className="object-fit-cover w-100" style={{ height: 500, ...addStyle }} />
        </div>
    );
}
